(function () {
  // ボタンクリック時にフラグを立て、Flickity の next/previous を抑止
  var _blockFlickityNav = false;

  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // モーダルを body 直下に移動（Flickity の transform / overflow の影響を回避）
  function ensureModalInBody() {
    var modals = document.querySelectorAll('.c_image-linked-products__modal');
    modals.forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  // Flickity インスタンスの next()/previous() をラップ
  function patchFlickityInstance(instance) {
    if (instance._imageLinkedPatched) return;
    instance._imageLinkedPatched = true;

    var origNext = instance.next;
    var origPrevious = instance.previous;

    instance.next = function () {
      if (_blockFlickityNav) {
        _blockFlickityNav = false;
        return;
      }
      return origNext.apply(this, arguments);
    };

    instance.previous = function () {
      if (_blockFlickityNav) {
        _blockFlickityNav = false;
        return;
      }
      return origPrevious.apply(this, arguments);
    };
  }

  // カルーセル要素にパッチを適用し、reload 後の再適用も登録
  function patchFlickityCarousels() {
    var carousels = document.querySelectorAll('flickity-carousel[click-nav]');
    carousels.forEach(function (carousel) {
      if (carousel._imageLinkedListening) return;
      carousel._imageLinkedListening = true;

      // 現在のインスタンスにパッチ
      if (carousel.flickityInstance) {
        carousel.flickityInstance.then(patchFlickityInstance);
      }

      // reload() で Flickity が destroy → 再生成されるため
      // flickity:ready イベントで新インスタンスに再パッチする
      carousel.addEventListener('flickity:ready', function () {
        if (carousel.flickityInstance) {
          carousel.flickityInstance.then(patchFlickityInstance);
        }
      });
    });
  }

  // DOM 準備後に実行
  function init() {
    ensureModalInBody();
    patchFlickityCarousels();
    // Flickity が遅延初期化される場合に備えて少し遅らせて再実行
    setTimeout(patchFlickityCarousels, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // トリガーボタンの pointerdown/mousedown でフラグを立てる
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest('.c_image-linked-products__trigger')) {
      _blockFlickityNav = true;
    }
  }, true);

  document.addEventListener('mousedown', function (e) {
    if (e.target.closest('.c_image-linked-products__trigger')) {
      _blockFlickityNav = true;
    }
  }, true);

  // トリガーボタン → モーダルを開く（キャプチャフェーズ）
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.c_image-linked-products__trigger');
    if (trigger) {
      e.preventDefault();
      e.stopImmediatePropagation();
      _blockFlickityNav = false;
      var modalId = trigger.getAttribute('aria-controls');
      var modal = document.getElementById(modalId);
      if (modal) {
        openModal(modal);
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
  }, true);

  // 閉じるボタン or オーバーレイ
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('.c_image-linked-products__modal [data-action="close"]');
    if (closeBtn) {
      var modal = closeBtn.closest('.c_image-linked-products__modal');
      if (modal) {
        closeModal(modal);
        var trigger = document.querySelector('[aria-controls="' + modal.id + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    }
  });

  // Escキーで閉じる
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openModals = document.querySelectorAll('.c_image-linked-products__modal[aria-hidden="false"]');
      openModals.forEach(function (modal) {
        closeModal(modal);
        var trigger = document.querySelector('[aria-controls="' + modal.id + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
